/* eslint-disable max-len */
import React from 'react';
import styles from './quotes.module.css';

function QuotesPage() {
  return (
    <div className={styles.quotesPages}>
      <p>
        Mathematics is not about numbers, equations, computations, or algorithms: It about undersanding. - William Paul Thurston
      </p>
    </div>
  );
}

export default QuotesPage;
